import React from 'react';
import '../Colors.css';

const NoRouteFound = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.46 283.46" enableBackground="new 0 0 283.46 283.46" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g id="bkg" display="none"> </g>
      <g id="picto">
        <g>
          <path fillRule="evenodd" clipRule="evenodd" className='HslGrey' d="M258.146,106.881c13.982,0,25.316,11.107,25.316,24.809
          c0,13.701-25.316,45.482-25.316,45.482s-25.316-31.781-25.316-45.482C232.83,117.988,244.164,106.881,258.146,106.881z"/>
          <g>
            <path fill="#FFFFFF" d="M249.904,124.683c0-1.28,1.012-2.291,2.291-2.291h7.379c2.38,0,4.255,0.655,5.445,1.845
            c0.952,0.952,1.428,2.113,1.428,3.541v0.06c0,2.351-1.25,3.66-2.738,4.493c2.41,0.922,3.898,2.321,3.898,5.118v0.06
            c0,3.809-3.095,5.713-7.796,5.713h-7.617c-1.28,0-2.291-1.012-2.291-2.291V124.683z M258.592,130.812
            c2.023,0,3.303-0.655,3.303-2.202v-0.059c0-1.369-1.071-2.142-3.005-2.142h-4.523v4.404H258.592z M259.812,139.203
            c2.023,0,3.243-0.714,3.243-2.262v-0.059c0-1.399-1.042-2.262-3.392-2.262h-5.296v4.582H259.812z"/>
          </g>
          <path fillRule="evenodd" clipRule="evenodd" className='HslGrey' d="M25.314,106.881c13.982,0,25.316,11.107,25.316,24.809
          c0,13.701-25.316,45.482-25.316,45.482S-0.002,145.39-0.002,131.689C-0.002,117.988,11.332,106.881,25.314,106.881z"/>
          <g>
            <path fill="#FFFFFF" d="M15.256,140.274l7.26-16.395c0.506-1.131,1.428-1.815,2.678-1.815h0.268c1.25,0,2.142,0.684,2.648,1.815
            l7.26,16.395c0.149,0.327,0.238,0.625,0.238,0.922c0,1.22-0.952,2.202-2.172,2.202c-1.071,0-1.785-0.625-2.202-1.577
            l-1.398-3.273h-9.165l-1.458,3.422c-0.387,0.893-1.16,1.428-2.113,1.428c-1.19,0-2.113-0.952-2.113-2.142
            C14.988,140.929,15.107,140.601,15.256,140.274z M28.14,134.502l-2.886-6.873l-2.887,6.873H28.14z"/>
          </g>
          <g>
            <path className='HslWarningRed' d="M138.913,158.592c-2.852,0-4.959-2.108-5.331-4.959l-1.24-10.663c-0.496-3.348,1.488-5.827,4.835-6.199
            c11.655-1.116,18.102-5.579,18.102-13.39v-0.248c0-6.943-5.331-11.779-14.258-11.779c-6.571,0-11.903,2.356-16.862,6.819
            c-1.24,0.992-2.852,1.736-4.587,1.736c-3.844,0-6.943-3.1-6.943-6.819c0-1.86,0.744-3.844,2.48-5.331
            c6.571-6.199,14.878-10.291,26.285-10.291c17.358,0,29.136,9.671,29.136,25.169v0.248c0,15.622-11.283,22.689-25.045,25.045
            l-0.496,5.703c-0.496,2.728-2.48,4.959-5.331,4.959H138.913z M138.913,167.643c5.083,0,8.803,3.72,8.803,8.555v1.24
            c0,4.835-3.72,8.555-8.803,8.555s-8.803-3.72-8.803-8.555v-1.24C130.11,171.362,133.83,167.643,138.913,167.643z"/>
          </g>
          <path fillRule="evenodd" clipRule="evenodd" className='HslGrey' d="M107.409,181.528H43.266c-1.697,0-3.074-1.376-3.074-3.074
          v-0.179c0-1.697,1.376-3.074,3.074-3.074h64.144c1.697,0,3.074,1.376,3.074,3.074v0.179
          C110.483,180.152,109.107,181.528,107.409,181.528z"/>
          <path fillRule="evenodd" clipRule="evenodd" className='HslGrey' d="M240.194,181.528h-64.144c-1.697,0-3.074-1.376-3.074-3.074
          v-0.179c0-1.697,1.376-3.074,3.074-3.074h64.144c1.697,0,3.074,1.376,3.074,3.074v0.179
          C243.268,180.152,241.892,181.528,240.194,181.528z"/>
        </g>
      </g>
    </svg>
  );
};

export default NoRouteFound;